import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import NotificationAlertLayer from "../components/school/NotificationAlertLayer";



const NotificationPage = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Settings - Notification" />

 <NotificationAlertLayer />

      </MasterLayout>

    </>
  );
};

export default NotificationPage; 
